var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-error"},[_c('p',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.message))]),_c('div',{staticClass:"clearfix"})])
}
var staticRenderFns = []

export { render, staticRenderFns }